import { NotificationEntityType } from "services/api/notifications/types";

import { NotificationIntroScene, NotificationStepText } from "./types";

/** Naslov i objašnjenje ispod scene, po sceni; prvi i zadnji korak ovise o tome je li notifikacija nova. */
export const NOTIFICATION_INTRO_TEXTS: Record<"create" | "edit", Record<NotificationIntroScene, NotificationStepText>> = {
  create: {
    type: {
      title: "Na što vas podsjetiti?",
      description: "Odaberite što pratimo. Obavijest stiže prije isteka registracije, osiguranja ili vatrogasnog aparata.",
    },
    message: {
      title: "Kako i što poručiti?",
      description: "Odaberite kanale slanja i uredite poruku. Naziv, datum i broj dana popunjavaju se sami.",
    },
    entities: {
      title: "Za koje stavke?",
      description: "Odaberite pojedinačne stavke za koje želite primati obavijesti. Ostale se ne prate.",
    },
    recipients: {
      title: "Tko prima obavijest?",
      description: "Odaberite uloge ili pojedine korisnike. Za email treba adresa, a za SMS broj mobitela.",
    },
    rules: {
      title: "Kada poslati?",
      description: "Postavite koliko dana prije isteka stiže prva obavijest i koliko se puta ponavlja.",
    },
    summary: {
      title: "Provjerite i spremite",
      description: "Pregledajte postavke prije spremanja. Nakon spremanja obavijesti se šalju same.",
    },
  },
  edit: {
    type: {
      title: "Uredite notifikaciju",
      description: "Provjerite što se prati. Promjene vrijede od sljedećeg slanja.",
    },
    message: {
      title: "Kako i što poručiti?",
      description: "Promijenite kanale ili tekst poruke. Naziv, datum i broj dana popunjavaju se sami.",
    },
    entities: {
      title: "Za koje stavke?",
      description: "Dodajte ili maknite stavke za koje želite primati obavijesti. Ostale se ne prate.",
    },
    recipients: {
      title: "Tko prima obavijest?",
      description: "Ažurirajte uloge ili pojedine korisnike. Za email treba adresa, a za SMS broj mobitela.",
    },
    rules: {
      title: "Kada poslati?",
      description: "Promijenite koliko dana prije isteka stiže prva obavijest i koliko se puta ponavlja.",
    },
    summary: {
      title: "Provjerite i spremite",
      description: "Pregledajte promjene prije spremanja. Nova pravila vrijede od sljedećeg slanja.",
    },
  },
};

/** Primjeri dok korisnik ništa nije odabrao ni upisao. */
export const NOTIFICATION_INTRO_SAMPLE = {
  entityType: NotificationEntityType.VehicleRegistration,
  daysBeforeExpiry: 30,
  channels: ["Email", "Push"],
  message: "Registracija vozila ZG 1234 AB uskoro ističe. Na vrijeme dogovorite tehnički pregled.",
  recipients: [
    { initials: "AK", name: "Ana Kovačević", role: "Voditelj flote" },
    { initials: "MP", name: "Marko Perić", role: "Administrator" },
    { initials: "IH", name: "Iva Horvat", role: "Prodaja" },
  ],
  entities: ["ZG 1234 AB", "ST 552 KL", "RI 908 CD", "OS 311 EF"],
};

/** Primjer naziva entiteta u pregledu poruke, po tipu. */
export const NOTIFICATION_SAMPLE_ENTITY_NAMES: Record<number, string> = {
  [NotificationEntityType.FireExtinguisher]: "Aparat P6 br. 118",
  [NotificationEntityType.VehicleRegistration]: "ZG 1234 AB",
  [NotificationEntityType.VehicleInsurance]: "ZG 1234 AB",
  [NotificationEntityType.Offer]: "Ponuda 2026/0142",
  [NotificationEntityType.Contract]: "Ugovor 2026/0087",
  [NotificationEntityType.Invoice]: "Račun 2026/0311",
  [NotificationEntityType.Custom]: "Servis vozila",
};

/** Tipovi prikazani na sceni odabira; odabrani se dodaje ako nije među njima. */
export const NOTIFICATION_INTRO_TYPES = [
  NotificationEntityType.VehicleRegistration,
  NotificationEntityType.VehicleInsurance,
  NotificationEntityType.FireExtinguisher,
  NotificationEntityType.Invoice,
];
